module.exports = __webpack_public_path__ + "static/img/news3-m@2x.5a6c9b1c.png";